import { render, staticRenderFns } from "./MainColumns.vue?vue&type=template&id=44b62e4e&"
import script from "./MainColumns.vue?vue&type=script&lang=js&"
export * from "./MainColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports